import type { ComponentProps } from "react";

const ZIPFileIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="63"
      height="60"
      viewBox="0 0 63 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M53.7211 58.6046H23.0235C19.1703 58.6046 16.0467 55.4811 16.0467 51.6279V8.37209C16.0467 4.51894 19.1703 1.39535 23.0235 1.39535H41.6315L60.6979 20.4617V51.6279C60.6979 55.4811 57.5743 58.6046 53.7211 58.6046Z"
        fill="#E9ECEF"
        stroke="#CED4DA"
        strokeWidth="2.7907"
      />
      <rect
        y="26.5117"
        width="41.8605"
        height="24.4186"
        rx="4.88372"
        fill="#FFB23B"
      />
    </svg>
  );
};

export default ZIPFileIcon;
